$(document).ready(function(){
  $('.hs-site-search').click(function() {
    $('.hs-site-search-header').toggleClass('search-hide');
    $('.site-overlay').toggleClass('active');
    $('.site-overlay').css("z-index", "9998");
    setTimeout(function(){
      $(".hs-search-input").focus();
    },50);
  });

  $('.hs-site-search-header .hs-site-search').click(function() {
    $('.site-overlay').css("z-index", "9999");
  });
  
  // $('.site-overlay').click(function() {
  //   $('.hs-site-search-header').addClass('search-hide');
  //   $('.site-overlay').toggleClass('active');
  //   $('.site-overlay').css("z-index", "9999");
  // });
});